// src/store/languageSlice.js — état i18n (S1)
// current = langue active ; supported/default = config du tenant (filtre le switcher).
import { createSlice } from '@reduxjs/toolkit'
import { DEFAULT_LOCALE } from '../utils/locales'

const initialState = {
  current: DEFAULT_LOCALE,
  supported: [DEFAULT_LOCALE],
  default: DEFAULT_LOCALE,
}

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setCurrentLanguage(state, action) {
      state.current = action.payload
    },
    setTenantLocales(state, action) {
      state.default = action.payload.default || DEFAULT_LOCALE
      state.supported = action.payload.supported || [DEFAULT_LOCALE]
    },
  },
})

export const { setCurrentLanguage, setTenantLocales } = languageSlice.actions
export default languageSlice.reducer
